import {USER_ACTIONS} from "../actions/types";
import {updateCache} from "ith-redux-helpers";
import {UPDATE_USER_LIST} from "../actions";

const defaultState = {
	data: null,
	list: []
};

export default (state = defaultState, {type, user, list, admin}) => {
	switch(type) {
		case USER_ACTIONS.SET:
			if ( null === user ) {
				return {
					...state,
					data: null
				};
			}
			return {...state, data: user, ...updateCache()};
		case USER_ACTIONS.SET_LIST:
			return {
				...state,
				list,
				...updateCache(UPDATE_USER_LIST)
			};
		case USER_ACTIONS.UNSET_LIST:
			return {
				...state,
				list: []
			};
		case USER_ACTIONS.ADD_ADMIN:
			return {
				...state,
				list: [...state.list, admin],
				...updateCache(UPDATE_USER_LIST)
			};
		case USER_ACTIONS.REMOVE_ADMIN:
			return {
				...state,
				list: state.list.filter(({admin_id}) => admin_id !== admin.admin_id),
				...updateCache(UPDATE_USER_LIST)
			};
		case USER_ACTIONS.UPDATE_PROFILE:
			return {
				list: state.list.map(admin => admin.admin_id === user.admin_id ? user : admin),
				data: user,
				...updateCache()
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js